import React, { useState } from "react";
import nurbs from "../assets/geometry/geo_nurbs.png";
import harmonics from "../assets/geometry/geo_harmonics.png";
import skeleton from "../assets/geometry/geo_skelneton.png";
import threed from "../assets/geometry/geo_3d.png";


const Geometries = () => {

  return (
    <section className="pt-2">
      {/* <Navbar /> */}
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <br></br>
          <p style={{ textAlign: 'center',fontSize:"1.5rem"}}>Our dataset includes four distinct categories of geometries. We provide the shapes and code for recreating these geometries in our code:</p>
            {/* type 1 */}
            <div style={{ backgroundColor: "#e0e0e0", color: "#000", padding: "1rem", borderRadius: "0.5rem"  }}>
              <span className="greeting" style={{ fontSize: "2rem",fontFamily: "Times New Roman", }}>G1: NURBS</span>
            </div>
            <p style={{ color: "#540", fontSize: "1rem", textAlign: "justify", textAlignLast: "center" }}>The first set of geometries consists of parametric shapes generated using Non-Uniform Rational B-Splines (NURBS) curves.</p>
              <img src={nurbs} alt="GIF" style={{ maxWidth: "40%", marginTop: "1rem" }} />
              <p style={{ textAlign: 'center', fontStyle: 'italic',fontFamily:"Times New Roman" }}>G1:  Sample of 28 geometries in FlowBench generated from NURBS.</p>
              <br /><br />
              {/* end */}
              {/* type 2 */}
            <div style={{ backgroundColor: "#e0e0e0", color: "#000", padding: "1rem", borderRadius: "0.5rem" }}>
              <span className="greeting" style={{ fontSize: "2rem",fontFamily: "Times New Roman", }}>G2: Harmonics</span>
            </div>
            <p style={{ color: "#540", fontSize: "1rem", textAlign: "justify", textAlignLast: "center" }}>The second set of geometries consists of parametric shapes generated using spherical harmonics..</p>
              <img src={harmonics} alt="GIF" style={{ maxWidth: "40%", marginTop: "1rem" }} />
              <p style={{ textAlign: 'center', fontStyle: 'italic',fontFamily:"Times New Roman" }}>G2: Sample of 28 geometries in FlowBench generated from spherical harmonics.</p>
              <br /><br />
              {/* end */}
              {/* type 3 */}
            <div style={{ backgroundColor: "#e0e0e0", color: "#000", padding: "1rem", borderRadius: "0.5rem" }}>
              <span className="greeting" style={{ fontSize: "2rem",fontFamily: "Times New Roman", }}>G3: Skelneton</span>
            </div>
            <p style={{ color: "#540", fontSize: "1rem", textAlign: "justify", textAlignLast: "center" }}>The third set of geometries consists of non-parametric shapes sampled from the grayscale dataset in SkelNetOn.</p>
              <img src={skeleton} alt="GIF" style={{ maxWidth: "40%", marginTop: "1rem" }} />
              <p style={{ textAlign: 'center', fontStyle: 'italic',fontFamily:"Times New Roman" }}>G3: Sample of 28 geometries in FlowBench generated from SkelNetOn.</p>
              <br /><br />
              {/* end */}
          </div>
            {/* type 4 */}
            {/* <div style={{ backgroundColor: "#e0e0e0", color: "#000", padding: "1rem", borderRadius: "0.5rem" }}>
            <span className="greeting" style={{ fontSize: "2rem",fontFamily: "Times New Roman"}}>Geometry Type 4: Ellipsoids and Toroids</span>
          </div>
          <p style={{ color: "#540", fontSize: "1rem", textAlign: "justify", textAlignLast: "center" }}>The third set of geometries includes 3D parametric ellipsoids, which are defined by varying the major and minor radii, and toroids, which are characterized by altering the inner and outer radii.</p>
            <img src={threed} alt="GIF" style={{ maxWidth: "60%", marginTop: "1rem" }} />
            <p style={{ textAlign: 'center', fontStyle: 'italic',fontFamily:"Times New Roman" }}>Geometry Type 4: Sample of 21 geometries in FlowBench generated from ellipsoids and toroids.</p> */}
            <div style={{ backgroundColor: "#e0e0e0", color: "#000", padding: "1rem", borderRadius: "0.5rem", textAlign: "center" }}>
  <span className="greeting" style={{ fontSize: "2rem", fontFamily: "Times New Roman" }}>G4: Ellipsoids and Toroids</span>
</div>
<p style={{ color: "#540", fontSize: "1rem", textAlign: "justify", textAlignLast: "center" }}>The fourth set of geometries includes 3D parametric ellipsoids, which are defined by varying the major and minor radii, and toroids, which are characterized by altering the inner and outer radii.</p>
<img src={threed} alt="GIF" style={{ maxWidth: "60%", marginTop: "1rem", marginLeft: "auto", marginRight: "auto" }} />
<p style={{ textAlign: 'center', fontStyle: 'italic', fontFamily: "Times New Roman" }}>G4: Sample of 21 geometries in FlowBench generated from ellipsoids and toroids.</p>
<br /><br />
{/* end */}
            <br /><br />
            {/* end */}
          </div>
        {/* </div> */}
      </div>
    </section>
  );
}

export default Geometries;